import logo from './logo.svg';
import './App.css';
import WatsonAPI from './WatsonAPI';



function App() {
  return (
    <div className="App">
       <div className="App">
          <WatsonAPI />
       </div>
    </div>
  );
}

export default App;
